import DeleteButton from "./DeleteButton";

DeleteButton.install = function(Vue) {
  Vue.component(DeleteButton.name, DeleteButton);
};

export default DeleteButton;
